import React from 'react'
import Tr from 'translations/Translations';
import AddIcon from '@material-ui/icons/AddCircle';
import AddIconOutlined from '@material-ui/icons/AddCircleOutline';
import WorkableIconButton from "./WorkableIconButton";
import PropTypes from "prop-types";

function WorkableIconAddButton({
	tooltip = Tr('add'),
	outlined = false,
	...props
}) {
	return <WorkableIconButton
		tooltip={tooltip}
		Icon={outlined ? AddIconOutlined : AddIcon}
		{...props}
	/>
}

WorkableIconAddButton.propTypes = {
	expanded: PropTypes.bool,
	working: PropTypes.bool,
	disabled: PropTypes.bool,
	tooltip: PropTypes.string,
	hideTooltip: PropTypes.bool,
	color: PropTypes.string,
	onClick: PropTypes.func
}

export default WorkableIconAddButton;